import React from "react";
import Modal from "react-bootstrap/Modal";
import styled from "styled-components";
import { LoadingIndicatorContext } from "./LoadingIndicatorContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/pro-regular-svg-icons";

interface Props {
  children: React.ReactNode;
}

const LoadingPageBody = styled.div`
  margin: 10px auto;
  padding: 20px;
  overflow: auto;
  height: 100%;
  width: 100%;

  @media screen and (max-width: 400px) {
    padding: 10px 5px;
  }
`;

const LoadingPage = () => {
  return (
    <LoadingPageBody
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        margin: 0,
        height: "100%",
      }}
    >
      <div>
        <div>
          <FontAwesomeIcon icon={faCircleNotch} spin={true} size="4x" />
        </div>
        <div>Loading...</div>
      </div>
    </LoadingPageBody>
  );
};

export const LoadingIndicatorProvider = (props: Props) => {
  const [loadingCounter, setLoadingCounter] = React.useState<number>(0);

  const onStartLoading = React.useCallback(() => {
    // Ensure that the Modal gets rendered in a different JS event loop tick
    // to avoid conflicts with other components that might be modifying overflow props
    // on the document's `body` (like the profile menu).
    setTimeout(() => setLoadingCounter((value) => value + 1), 0);
  }, []);

  const onStopLoading = React.useCallback(() => {
    // setTimeout: see comment above
    setTimeout(() => setLoadingCounter((value) => value - 1), 0);
  }, []);

  const contextValue = React.useMemo(
    () => ({ onStartLoading, onStopLoading }),
    [onStartLoading, onStopLoading]
  );

  return (
    <>
      <Modal
        show={loadingCounter > 0}
        backdrop="static"
        keyboard={false}
        fullscreen={true}
        animation={false}
      >
        <Modal.Body>
          <LoadingPage></LoadingPage>
        </Modal.Body>
      </Modal>

      <LoadingIndicatorContext.Provider value={contextValue}>
        {props.children}
      </LoadingIndicatorContext.Provider>
    </>
  );
};
